import { useQuery } from "react-query";
import { getAllHissaUsers } from "../api/idServerApi";

export function useGetAllHissaUsers() {
  return useQuery({
    queryKey: "getAllHissaUsers",
    queryFn: getAllHissaUsers,
    retry: false,
  });
}
